import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Card, PageHeader, Spinner, Badge, StatCard } from "@/components/ui";
import { money } from "@/lib/utils";
import { Users, Receipt, ShieldCheck, Building2 } from "lucide-react";

export default function ProviderPortal() {
  const [members, setMembers] = useState(null);
  const [claims, setClaims] = useState(null);
  const [um, setUm] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/members").then((r) => setMembers(r.data.slice(0, 10)));
    api.get("/claims").then((r) => setClaims(r.data.slice(0, 10)));
    api.get("/um-requests").then((r) => setUm(r.data.filter((u) => u.status.includes("Pending")).slice(0, 6)));
  }, []);

  if (!members || !claims || !um) return <Spinner />;

  return (
    <div className="vc-fade-up">
      <PageHeader title="Provider Portal" subtitle="Panel roster, claim status, and authorization requests for your organization." />

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard label="Attributed Members" value={members.length} icon={Users} tone="brand" />
        <StatCard label="Recent Claims" value={claims.length} icon={Receipt} tone="blue" />
        <StatCard label="Pending Auths" value={um.length} icon={ShieldCheck} tone="amber" />
        <StatCard label="Network Status" value="Active" icon={Building2} tone="brand" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4">
        <Card className="overflow-hidden">
          <div className="px-5 py-4 border-b border-border"><h3 className="font-display font-semibold">My Panel</h3></div>
          <div className="divide-y divide-border">
            {members.map((m) => (
              <div key={m.id} onClick={() => navigate(`/members/${m.id}`)} className="flex items-center gap-3 px-5 py-3 hover:bg-muted cursor-pointer transition-colors">
                <img src={m.photo_url} alt="" className="h-9 w-9 rounded-full object-cover" />
                <div className="flex-1 min-w-0"><p className="text-sm font-medium">{m.first_name} {m.last_name}</p><p className="text-xs text-muted-foreground">{m.plan}</p></div>
                <Badge tone={m.risk_level}>{m.risk_level}</Badge>
              </div>
            ))}
          </div>
        </Card>

        <div className="space-y-4">
          <Card className="overflow-hidden">
            <div className="px-5 py-4 border-b border-border"><h3 className="font-display font-semibold">Recent Claim Status</h3></div>
            <div className="divide-y divide-border">
              {claims.map((c) => (
                <div key={c.id} className="flex items-center justify-between px-5 py-2.5">
                  <div><p className="text-sm font-mono">{c.claim_number}</p><p className="text-xs text-muted-foreground">{c.member_name} · {money(c.billed_amount)}</p></div>
                  <Badge tone={c.status}>{c.status}</Badge>
                </div>
              ))}
            </div>
          </Card>
          <Card className="overflow-hidden">
            <div className="px-5 py-4 border-b border-border"><h3 className="font-display font-semibold">Pending Authorizations</h3></div>
            <div className="divide-y divide-border">
              {um.length ? um.map((u) => (
                <div key={u.id} className="flex items-center justify-between px-5 py-2.5">
                  <div><p className="text-sm font-medium">{u.service}</p><p className="text-xs text-muted-foreground">{u.member_name}</p></div>
                  <Badge tone="Pending">{u.status}</Badge>
                </div>
              )) : <p className="px-5 py-4 text-sm text-muted-foreground">No pending authorizations</p>}
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
}
